"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=label-edit-capability.js.map